module.exports = __webpack_public_path__ + "img/ITW_Windzonen_Belgien.c206c251.svg";